export const logotypeStyles = {
  logo: {
    height: "40px",
    display: "flex",
    justifyContent: "flex-start"
  },
  logoLittle: {
    height: "43px",
    pl: 0
  }
};
